"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _GlobalErrorHandler = _interopRequireDefault(require("../../utils/GlobalErrorHandler"));
/* eslint-disable */
var _default = exports.default = _GlobalErrorHandler.default;